export default "__VITE_ASSET__Dom1nKvT__"